import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DashboardParams } from 'src/app/models/dashboardParams';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  basePath: string;
  
  constructor(private httpClient: HttpClient) {
  }

  getLoggedInUserStatistics(dashboardParams: DashboardParams) {
    let params = new HttpParams();

    if (dashboardParams.filterSelected !== undefined) {
      params = params.append('filterSelected', dashboardParams.filterSelected);
    }
    return this.httpClient.get(this.basePath + '/user/statistics', { params });
  }
  getDiskUsageStatistics() {
    return this.httpClient.get(this.basePath + '/user/statistics/disk');
  }
  getUploadStatistics() {
    return this.httpClient.get(this.basePath + '/user/statistics/upload');
  }
  getDownloadStatistics() {
    return this.httpClient.get(this.basePath + '/user/statistics/download');
  }
  getApplicationResponseTime(dashboardParams: DashboardParams) {
    let params = new HttpParams();
    if (dashboardParams.applicationResponseFilter !== undefined) {
      params = params.append("applicationResponseFilter", dashboardParams.applicationResponseFilter);
    }
    return this.httpClient.get(this.basePath + '/user/statistics/appResponse', { params });
  }
}
